import React, { FC } from "react";

import Button from "../../../../../components/elements/Button";
import classes from "../../CampaignsDashboard.module.scss";
import { successToaster } from "../../../../../helpers/toasters";

type CopyTrackingPixelButtonProps = {
  pixelEventId: number;
};

const CopyTrackingPixelButton: FC<CopyTrackingPixelButtonProps> = ({ pixelEventId }) => {
  const handleClick = () => {
    navigator.clipboard.writeText(`<code>
  &lt;!--BEGIN CONVERSION TAG, DO NOT REMOVE --&gt; &lt;script&gt; var cachebuster =
  Math.floor(Math.random() * 10000000000); var img = new Image(); img.width = 0; img.height = 0; img.src
  = 'https://cnv.event.prod.bidr.io./log/cnv?tag_id=${pixelEventId}
  &buzz_key=brandgen&value=[VALUE]&segment_key=${pixelEventId}
  &order=[ORDER]&ord=' + cachebuster; document.body.appendChild(img); //can be modified to
  wherever you want the image added/appended &lt;/script&gt; &lt;!--END CONVERSION TAG, DO NOT REMOVE
  --&gt;
</code>`);
    successToaster("Tracking Pixel is copied to clipboard!", 5000);
  };

  return (
    <div className={classes.copyTrackingPixelContiner}>
      <div className={classes.copyTrackingPixel}>
        <Button variant="contained" onClick={handleClick}>
          Copy Conversion Pixel
        </Button>
      </div>
    </div>
  );
};

export default CopyTrackingPixelButton;
